import React from 'react';
import { useTranslation } from 'react-i18next';
import TicketCardContainer from './ticket';
import {Button} from '../ui/card/card';
import NeoInfo from '../neoInfo';
import { APIAction } from '../order-menu/api-action/api-action';

import './ticket-confirm.css';

export default function TicketView({ config, onSubmit }) {
	const { t } = useTranslation();
	const ticket_view = config['ticket-view'];
	const { attendee, actions } = ticket_view; // eslint-disable-line
	const successMessage = {info: t('widget.step-confirm.confirm-message')};

	return (
		<div className='wz-confirm-container'>
			<div className='wz-confirm-title'><strong>{t('widget.step-confirm.title')}</strong></div>
			<NeoInfo config={ successMessage } variant='success'/>
			<TicketCardContainer attendee={attendee}/>
			<div className="wz-confirm-footer">
				<APIAction name={'OrderMenuStep'} actions={ actions }>
					<Button
						className='wz-cta-back'
						onClick={() => onSubmit({
							data: {
								action: 'OrderMenuStep',
							}
						})}
					>
						{t('widget.ticket.back-to-order')}
					</Button>
				</APIAction>
				<APIAction name={'DownloadTicketStep'} actions={ actions }>
					<Button
						className='wz-cta-download'
						onClick={() => onSubmit({data: {action: 'DownloadTicketStep', payload: { attendee_id: attendee.id }}})}
					>
						{t('widget.step-confirm.cta-download')}
					</Button>
				</APIAction>
			</div>
		</div>
	)
}
